export const AD_POSITION_VALUES = ['top', 'middle', 'horizontal_top', 'horizontal_middle']

export const AD_POSITION_HINTS = {
  top: 'homepage: sidebar top | listings: after 1st row',
  middle: 'homepage: sidebar middle | listings: after 3rd row',
  horizontal_top: 'homepage: between breaking news and hero (full-width strip)',
  horizontal_middle: 'homepage: between latest news and category sections',
}

export const STATIC_AD_PAGE_VALUES = [
  'all_news',
  'latest_news',
  'trending',
  'most_read',
  'recommended',
  'city_updates',
  'article',
]

export const AD_PAGE_VALUES = ['home', ...STATIC_AD_PAGE_VALUES]

/** Matches Sequelize DataTypes.STRING / MySQL VARCHAR(255) on advertisements.title */
export const ADVERTISEMENT_TITLE_MAX_LENGTH = 255

export const AD_PAGE_HINTS = {
  home: 'Homepage (/)',
  all_news: 'All News (/all-news)',
  latest_news: 'Latest News (/latest-news)',
  trending: 'Trending (/trending)',
  most_read: 'Most Read (/most-read)',
  recommended: 'Recommended (/recommended)',
  city_updates: 'City Updates (/city/{slug})',
  article: 'News Article (/news/...) — shows in all article placeholders',
}

export const AD_PAGES = AD_PAGE_VALUES.map((value) => ({
  value,
  label: `${value} — ${AD_PAGE_HINTS[value] || value}`,
}))

export const AD_POSITION_OPTIONS = AD_POSITION_VALUES.map((value) => ({
  value,
  label: `${value} — ${AD_POSITION_HINTS[value] || value}`,
}))

export const LISTING_NEWS_PER_PAGE = 20

export function getPositionLabel(position) {
  const hint = AD_POSITION_HINTS[position]
  return hint ? `${position} — ${hint}` : position
}

export function getPageLabel(value) {
  const hint = AD_PAGE_HINTS[value]
  return hint ? `${value} — ${hint}` : value
}

export function formatPagesList(pages = []) {
  if (!Array.isArray(pages) || pages.length === 0) return '—'
  return pages.map((page) => getPageLabel(page)).join(', ')
}

export function formatPositionsList(positions = []) {
  if (!Array.isArray(positions) || positions.length === 0) return '—'
  return positions.map((position) => getPositionLabel(position)).join(', ')
}

export function getAllPositionFilterOptions() {
  return AD_POSITION_OPTIONS
}

export function normalizeAdvertisementTargeting(record = {}) {
  const rawPages = Array.isArray(record.pages)
    ? record.pages
    : record.page
      ? [record.page]
      : []

  const rawPositions = Array.isArray(record.positions)
    ? record.positions
    : record.position
      ? [record.position]
      : []

  // Legacy page key from earlier category-ad work — migrate to the flag
  const hadLegacyCategoryPage = rawPages.includes('category')

  const pages = rawPages.filter((page) => AD_PAGE_VALUES.includes(page))

  // Drop unknown/removed positions so admin form stays valid
  const positions = rawPositions.filter((position) =>
    AD_POSITION_VALUES.includes(position)
  )

  const showOnCategoryPages =
    Boolean(record.showOnCategoryPages) || hadLegacyCategoryPage

  return { pages, positions, showOnCategoryPages }
}
